import React from 'react';
import PropTypes from 'prop-types';

import { ChirpButton } from 'javascripts/components/chirp_button';

import { bubEvents } from 'javascripts/shared/events/bub_events';

import giftIcon from 'images/Gift.png';

export function GiftAudiobookButton({ giftPurchaseUrl, condensed, small }) {
  function handleClick() {
    bubEvents.track('Gifting', 'Clicked button', {
      label: 'Give as a gift',
    });

    if (window.gtag !== undefined) {
      gtag('event', 'buy_now', {
        event_category: 'purchase',
        event_label: $('.book-title').text(),
      });
    }
  }

  return (
    <ChirpButton
      attrs={{ rel: 'nofollow' }}
      displayStyle='gray'
      displayStyleHover='navy'
      displayType='link'
      href={giftPurchaseUrl}
      icon={giftIcon}
      iconHover={giftIcon}
      label={condensed ? 'Gift' : 'Give as a Gift'}
      onClick={handleClick}
      fontSize={small ? 'small' : 'medium'}
    />
  );
}

GiftAudiobookButton.propTypes = {
  giftPurchaseUrl: PropTypes.string.isRequired,
  condensed: PropTypes.bool,
  small: PropTypes.bool,
};
